import { EmployeeFullName } from "@me-team/host/src/utils/type";
import { format } from "date-fns";
import { OperationHistoriesType } from "./types";
import { IHistoryData } from "./OperationHistoryDataItem/OperationHistoryDataItem";
import { StorageProductRelationHistoryAction } from "@me-team/host/main/graphql/types";

export const getFullName = (employee: EmployeeFullName): string => `${employee.name} ${employee.surname}`;
const joinNonEmptyParts = (parts: Array<string | null | undefined>, separator: string) =>
    parts
        .map((part) => (part ?? "").trim())
        .filter(Boolean)
        .join(separator);

const formatEmployeeDisplay = (historyDataItem: IHistoryData) => {
    const employeeName = historyDataItem.employee?.name ?? null;
    const employeeSurname = historyDataItem.employee?.surname ?? null;
    const fullEmployeeName = joinNonEmptyParts([employeeName, employeeSurname], " ");
    return fullEmployeeName || (historyDataItem.value ?? "");
};

const formatClientDisplay = (historyDataItem: IHistoryData) => {
    const clientName = historyDataItem.client?.name ?? null;
    const clientPhone = historyDataItem.client?.phone ?? null;
    const clientEmail = historyDataItem.client?.email ?? null;

    const clientInfoCombined = joinNonEmptyParts([clientName, clientPhone, clientEmail], " ");

    return clientInfoCombined || (historyDataItem.value ?? "");
};

export const formatDateValue = (historyData: IHistoryData) => {
    if (historyData.field === "date" || historyData.field === "booking") {
        const date = new Date(historyData.value);
        return format(date, "dd.MM.yyyy HH:mm");
    }

    if (historyData.field === "storage" && historyData.storage) {
        return historyData.storage.name;
    }

    if (historyData.field === "employee") {
        return formatEmployeeDisplay(historyData);
    }

    if (historyData.field === "client") {
        return formatClientDisplay(historyData);
    }

    return historyData.value;
};

export const transformFieldNames = (field: string) => {
    switch (field) {
        case "cost":
            return "Cost price";
        case "price":
            return "Selling price";
        default:
            return field;
    }
};

export const findPreviousWithField = (
    originalHistories: OperationHistoriesType[],
    startIndex: number,
    field: string
) => {
    for (let i = startIndex - 1; i >= 0; i--) {
        const item = originalHistories[i];
        if (!item) continue;
        const fieldData = item.storageProductOperationHistoryData?.find((d) => d.field === field);
        if (fieldData) return fieldData;
    }
    return undefined;
};

export const operationActionToTranslationKey: Record<StorageProductRelationHistoryAction, string> = {
    [StorageProductRelationHistoryAction.Arrival]: "Arrival of goods",
    [StorageProductRelationHistoryAction.BookingWriteOff]: "Booking write-off of goods",
    [StorageProductRelationHistoryAction.Movement]: "Movement",
    [StorageProductRelationHistoryAction.Sale]: "Selling",
    [StorageProductRelationHistoryAction.WriteOff]: "Write-off of goods",
};
